
import { defineComponent, onMounted } from 'vue'
import { useMeta } from 'vue-meta'
import { RoofHeaderText, RoofTable } from '@squareroof-admin/ui-components'
import { Logic } from '@unwind-admin/logic'
import { scrollToTop } from '@/composables'

export default defineComponent({
  components: {
    RoofHeaderText,
    RoofTable,
  },
  name: 'UserListPage',
  layout: 'Dashboard',
  middlewares: {
    fetchRules: [
      {
        domain: 'Users',
        property: 'Users',
        method: 'GetUsers',
        params: [8, 1, 'CREATED_AT', 'DESC'],
        requireAuth: true,
      },
    ],
  },
  setup() {
    useMeta({
      title: 'Users List',
    })

    const userList = Logic.Users.Users

    onMounted(() => {
      scrollToTop()
    })

    return {
      Logic,
      userList,
    }
  },
})
